<template>
  <div class="evaluation-start">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="evaluation-start__box">
            <div class="evaluation-start__evaluation">
              <span v-b-modal.clearAcceptDialog class="evaluation-start__clear">New Respondent</span>
              <div class="evaluation-start__img-container text-center">
                <img class="evaluation-start__img" src="~assets/img/icon.svg">
                <h1 class="evaluation-start__title">Organomyx</h1>
                <p class="evaluation-start__company">powered by Q5</p>
              </div>
              <button @click="beginEvaluation" class="custom-btn custom-btn--evalution">
                Begin Evaluation
              </button>
            </div>
            <div class="evaluation-start__results">
              <button @click="goToResults" class="custom-btn custom-btn--results" :to="{ name: 'terms' }">
                View Results
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="resultsDialog" centered hide-header hide-footer>
      <div class="results-modal">
        <div class="results-modal__content">
          <img class="results-modal__img" src="~assets/img/logo-header.png">
          <h2 class="results-modal__title">Let’s complete the evaluation!</h2>
          <p class="results-modal__text">Your group results will be displayed
            here once we collate your responses.</p>
        </div>
        <div class="results-modal__buttons-container">
          <button @click="hideResultsModal" class="results-modal__button" :to="{ name: 'terms' }">
            Cancel
          </button>
          <button @click="goToSections" class="results-modal__button">Continue</button>
        </div>
      </div>
    </b-modal>

    <b-modal id="clearAcceptDialog" ref="clearAcceptDialog" centered hide-header hide-footer>
      <div class="results-modal">
        <div class="results-modal__content">
          <img class="results-modal__img" src="~assets/img/logo-header.png">
          <h2 class="results-modal__title">Would you like to create a new respondent?</h2>
        </div>
        <div class="results-modal__buttons-container">
          <button @click="hideAcceptsModal" class="results-modal__button" :to="{ name: 'terms' }">
            Cancel
          </button>
          <button @click="clearRespondentData" class="results-modal__button">Yes</button>
        </div>
      </div>
    </b-modal>

    <b-modal id="errorDialog" ref="errorDialog" centered hide-header hide-footer>
      <div class="results-modal">
        <div class="results-modal__content">
          <img class="results-modal__img" src="~assets/img/logo-header.png">
          <h2 class="results-modal__title text-center px-3">You have already finished evaluation.<br>
            If you want to begin evaluation with a new respondent,<br>please click "New Respondent"</h2>
        </div>
        <div class="results-modal__buttons-container">
          <button @click="hideErrorModal" class="results-modal__button w-100">OK</button>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
// API
import subjectsApi from '@/api/subjects';

export default {
  data() {
    return {
      evaluationDone: '',
    };
  },
  methods: {
    beginEvaluation() {
      this.$router.push('tutorial');
    },
    goToResults() {
      this.$router.push('results');
    },
    goToSections() {
      if (this.$current_user.completed_sections && this.$current_user.completed_sections !== '0'
        && this.$current_user.current_evaluation === this.$route.params.id) {
        this.$router.push('sections');
      } else {
        this.$router.push('terms');
      }
    },
    hideResultsModal() {
      this.$refs.resultsDialog.hide();
    },
    hideAcceptsModal() {
      this.$refs.clearAcceptDialog.hide();
    },
    hideErrorModal() {
      this.$refs.errorDialog.hide();
    },
    clearRespondentData() {
      localStorage.clear();
      this.$refs.clearAcceptDialog.hide();
    },
  },
  created() {
    if (this.$current_user.auth_token) {
      subjectsApi.index().then((response) => {
        this.evaluationDone = true;
        Object.keys(response.data.subjects).forEach((key) => {
          if (!response.data.subjects[key].complete) {
            this.evaluationDone = false;
          }
        });
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Evaluation/Start.vue